import CommonUtils from '@/common/common-utils'
import { Texture } from 'three'

const CANVAS_WIDTH = 512
const CANVAS_HEIGHT = 128

export default class CanvasText {
  #canvas: HTMLCanvasElement
  #context: CanvasRenderingContext2D
  #texture: Texture
  #currentLeftText = ''
  #currentRightText = ''
  #textColor = '#FFFAEB'

  constructor() {
    this.#canvas = document.createElement('canvas') as HTMLCanvasElement
    this.#canvas.width = CANVAS_WIDTH
    this.#canvas.height = CANVAS_HEIGHT

    this.#canvas.getContext('2d')
    this.#context = this.#canvas.getContext('2d') as CanvasRenderingContext2D
    this.#context.fillStyle = '#FFFAEB'

    this.#texture = new Texture(this.#canvas)
    this.#texture.repeat.y = 4
  }

  clear() {
    this.#context.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT)
  }

  setTextColor(color: string) {
    this.#textColor = color
  }

  setLeftText(text: string) {
    if (this.#currentLeftText === text) {
      return
    }
    this.#currentLeftText = text
    this.clear()
    this.#context.textAlign = 'left'

    this.#context.font = '350 42px ' + this.getFont()

    this.#context.fillStyle = this.#textColor
    this.#context.fillText(text, 10, CANVAS_HEIGHT - 30)
    this.#texture.needsUpdate = true
  }

  getFont() {
    return 'CircularStd'
  }

  setRightText(text: string) {
    if (this.#currentRightText === text) {
      return
    }
    this.#currentRightText = text
    this.#context.fillStyle = this.#textColor
    this.#context.textAlign = 'right'
    this.#context.font = '350 40px ' + this.getFont()
    this.#context.fillText(text, CANVAS_WIDTH, CANVAS_HEIGHT - 40)
    this.#texture.needsUpdate = true
  }

  setRightName(text: string) {
    if (this.#currentRightText === text) {
      return
    }

    if (text.length > 10) {
      text = text.substring(0, 9) + '...'
    }

    this.#currentRightText = text
    this.clear()

    this.#context.fillStyle = this.#textColor
    this.#context.textAlign = 'right'
    this.#context.font = '350 35px ' + this.getFont()
    this.#context.fillText(text, CANVAS_WIDTH - 30, CANVAS_HEIGHT - 30)
    this.#texture.needsUpdate = true
  }

  getTexture() {
    return this.#texture
  }

  setColor(color: string) {
    this.#context.fillStyle = color
  }

  destroy() {
    if (this.#texture) {
      this.#texture.dispose()
    }
  }
}
